import React, {FC} from 'react';
import {BaseMap} from 'components/BaseMap';
import {LocationType} from 'components/BaseMap/Marker/MarkerIcon';
import {Location} from 'components/TimePicker/types';

import MapIcon from './svgs/map.inline.svg';
import PhoneIcon from './svgs/phone.inline.svg';

import * as styles from './styles.module.scss';

type LocationMapProps = {
	location: Location
}

const LocationMap: FC<LocationMapProps> = ({location}) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.title}>Location</div>
			<BaseMap
				className={styles.map}
				interactive={false}

				zoom={15}
				latitude={location.details.coords.lat}
				longitude={location.details.coords.lng}

				markers={[{
					id: '<location>',
					latitude: location.details.coords.lat,
					longitude: location.details.coords.lng,
					type: location.details.isStore ? LocationType.store : LocationType.van,
				}]}
				controls={{
					nav: {position: 'bottom-right'},
				}}
			/>
			<div className={styles.details}>
				<div>
					<MapIcon />
					<div>
						<h2>Address</h2>
						<span>
							{location.details.address.addr1}{', '}
							{location.details.address.addr2}
						</span>
					</div>
				</div>
				<div>
					<PhoneIcon />
					<div>
						<h2>Contact details</h2>
						<a href='tel:+13106018184'>(310) 601-8184</a>
						<a href='mailto:support@bodyspec.com'>support@bodyspec.com</a>
					</div>
				</div>
			</div>
		</div>
	);
};

export default LocationMap;
